/* eslint no-trailing-spaces: 0 */

const messages = {
  activate: {
    agreement_msg: 'Эта услуга предоставляется вам Ecosoft и Aplix Corporation. Используя эту услугу, вы принимаете и соглашаетесь с Условиями обслуживания Aplix HARPS (<a href =\'http://www.aplix.co.jp/en/legal/terms_harps.php\' target = \'_ blank \'> Условиями использования HARPS </a>, <a href=\'http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php\' target=\'_blank\'> Политикой конфиденциальности</a>) и арбитражом перед Международной торговой палатой по любым спорам между нами.'
  }
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/assets/connect_ecosoft_com/translations/japanese.js